import React from 'react';
import { Analytics } from '@vercel/analytics/react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import ToastContainer from './components/common/ToastContainer';
import AppRoutes from './pages/AppRoutes';
import TermsModal from './components/common/TermsModal';
import BillingInfoModal from './components/common/BillingInfoModal';

function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <Router>
          <AuthProvider>
            <AppRoutes />
            <TermsModal />
            <BillingInfoModal />
            <Analytics />
          </AuthProvider>
        </Router>
        <ToastContainer />
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;